import {needAuth} from "../instance/Instance";
import {commonChangeResponseMessage, commonResponseMessage} from "../../components/commonmethod/CommonMethod";



async function getAccessLogList(search, pageable) {
    const start = performance.now();
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;
    try{
        console.log(await needAuth.post('/accessLog?'+pageStr,search))
        return  await needAuth.post('/accessLog?'+pageStr,search);
    }catch (error){
        return error;
    }finally {
        const end = performance.now(); // 함수 호출 후 현재 시간 측정
        const executionTime = ((end - start)/1000).toFixed(2); // 함수 실행에 걸린 시간 계산
        console.log(`>>> api : 접속기록 리스트 조회 완료시간 : ${executionTime} 초`);
    }
}


async function getAccessLogBarChart(search) {
    const start = performance.now();




    try{
        console.log(await needAuth.post('/accessLog/chart',search))
        return  await needAuth.post('/accessLog/chart',search);
    }catch (error){
        return error;
    }finally {
        const end = performance.now(); // 함수 호출 후 현재 시간 측정
        const executionTime = ((end - start)/1000).toFixed(2); // 함수 실행에 걸린 시간 계산
        console.log(`>>> api : 접속기록 BarChart 조회 완료시간 : ${executionTime} 초`);
    }
}




export {getAccessLogList,getAccessLogBarChart};